import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CryptoService } from '../services/crypto.service';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const cryptoService = inject(CryptoService);
    const authService = inject(AuthService);

    const user = JSON.stringify(authService.getUser());
    if (user) {
        const encryptedUser = cryptoService.encrypt(user);
        const clonedReq = req.clone({
            setHeaders: {
                'X-Encrypted-U': encryptedUser
            }
        });
        return next(clonedReq);
    }

    return next(req);
};
